module.exports = __webpack_public_path__ + "img/188-peru.44e49951.svg";